import { render, staticRenderFns } from "./LoadingHero.vue?vue&type=template&id=391733d3&"
import script from "./LoadingHero.vue?vue&type=script&lang=js&"
export * from "./LoadingHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports